@if (enabled) {
  <app-update-policy-status-modal
    [policy]="policy"
    [status]="PolicyStatus.INACTIVE"
    titleText="Placer cette police hors mandat ?"
    i18n-titleText
    (updateSuccess)="refreshTaskDetails()"
  >
    <app-pause-icon
      height="16px"
      width="16px"
      color="var(--light-gray-500)"
      ngbTooltip="Placer hors mandat"
      i18n-ngbTooltip
      trigger
    />
  </app-update-policy-status-modal>
}
